import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';

export default class SkillDto extends BaseAgencyScopeEntityDto {
    status = 0;
    code: string;
    name: string;
    description: string;
}